(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapvero-v4-customer-surface"]) return;
  try {
    
  (() => {
    const bindCountry = (country) => {
      if (country.dataset.tv4Bound === 'true') return;
      const form = country.closest('form');
      const province = form?.querySelector('.tv4s-province');
      const wrap = province?.closest('.tv4s-province-wrap');
      if (!province || !wrap) return;
      const sync = () => {
        const selected = country.options[country.selectedIndex];
        let provinces = [];
        try { provinces = JSON.parse(selected?.dataset?.provinces || '[]'); } catch (error) { provinces = []; }
        province.replaceChildren();
        provinces.forEach((entry) => {
          const option = document.createElement('option');
          option.value = entry[0];
          option.textContent = entry[1];
          if (entry[0] === province.dataset.default) option.selected = true;
          province.append(option);
        });
        wrap.hidden = provinces.length === 0;
      };
      country.addEventListener('change', sync);
      country.dataset.tv4Bound = 'true';
      sync();
    };
    const init = (scope = document) => scope.querySelectorAll('.tv4s-country').forEach(bindCountry);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapvero-v4-info-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const customTopic = 'Custom Stand';

    const initializeContactForm = (root) => {
      if (!root || root.dataset.tv4ContactReady === 'true') return;

      const topic = root.querySelector('[data-tv4-contact-topic]');
      const customFields = root.querySelector('[data-tv4-custom-fields]');
      const context = root.querySelector('[data-tv4-contact-context]');
      if (!topic || !customFields || !context) return;

      const defaultContext = context.dataset.defaultContext || 'Tapvero website inquiry';
      const requiredWhenCustom = root.querySelectorAll('[data-tv4-custom-required], [data-tv4-custom-only-required]');
      const customOnlyFields = customFields.querySelectorAll('input, select, textarea');

      const updateCustomState = () => {
        const isCustom = topic.value === customTopic;
        customFields.hidden = !isCustom;
        context.value = isCustom ? `${defaultContext} | Custom Stand quote inquiry` : defaultContext;

        requiredWhenCustom.forEach((field) => {
          field.required = isCustom;
        });

        customOnlyFields.forEach((field) => {
          field.disabled = !isCustom;
        });
      };

      const requestedTopic = new URLSearchParams(window.location.search).get('topic');
      if (requestedTopic && requestedTopic.toLowerCase() === 'custom-stand') {
        topic.value = customTopic;
      }

      topic.addEventListener('change', updateCustomState);
      root.dataset.tv4ContactReady = 'true';
      updateCustomState();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-tv4-contact-root]').forEach(initializeContactForm);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
